<!--
  使用率兑付率弹窗
-->
<template>
  <div class="map-tooltips">
    <div class="header">
      <p>{{infoObj.name}}</p>
      <!-- <div @click.stop="close" class="close-div"></div> -->
    </div>
    <div class="body">
      <div class="item">
        <p class="item-left">累计在册数：</p>
        <p class="item-right">{{infoObj.vehicleTotal || 0}}台</p>
      </div>
      <div class="item">
        <p class="item-left">注册登记数：</p>
        <p class="item-right">{{infoObj.vehicleCount || 0}}台</p>
      </div>
      <div class="item">
        <p class="item-left">注销登记数：</p>
        <p class="item-right">{{infoObj.vehicleCancel || 0}}台</p>
      </div>
      <div class="item">
        <p class="item-left">驾驶员在册数：</p>
        <p class="item-right">{{infoObj.licenseTotal || 0}}人</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'map-tooltips',
  props: {
    infoObj: {
      type: Object,
      default: () => {}
    },
    vmm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.vmm.closeWindow();
    }
  }
}
</script>
<style lang="scss" scoped>
.map-tooltips {
  width: 250px;
  height: 174px;
  padding: 20px 30px;
  background: url('../../../../assets/images/governmentAffairs/vehiclesupervisor/map/bg_tk_jl_con.png') no-repeat;
  background-size: 100% 100%;
  opacity: 1;
  font-family: Microsoft YaHei;
  font-size: 14px;
  color: #3DB868;
  display: flex;
  flex-direction: column;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 18px;
    color: #FFFFFF;
    text-shadow: 1px 2px 0px #00552C;
    .close-div {
      width: 13px;
      height: 12px;
      background: url('../../../../assets/images/governmentAffairs/common/bg_tk_bf_con_close.png') no-repeat;
      background-size: 100% 100%;
    }
  }
  .body {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    padding-top: 4px;
    .item {
      display: flex;
      align-items: baseline;
      line-height: 22px;
      .item-left {
        width: 100px;
        margin-right: 4px;
        text-align: right;
      }
      .item-right {
        color: #C7FFDB;
        text-align: left;
      }
    }
  }
}
</style>
